import { getAmplitudeInstance } from '../amplitudeHelpers';
import FeedbackProvided from '../enums/FeedbackProvided';

type logReviewGPTFeedbackClickedParams = {
  feedback: FeedbackProvided;
  trail_id: number;
};

/**
 * Event fires when user clicks yes or no on feedback section of trail review generated by chatGPT to indicate if it was helpful or not.
 * @param params - Attributes to log with the amplitude event
 * @param params.feedback - the feedback provided by the user
 * @param params.trail_id - the trail id where the feedback was provided
 */
const logReviewGPTFeedbackClicked = ({ feedback, trail_id }: logReviewGPTFeedbackClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('review gpt feedback clicked', { feedback, 'trail id': trail_id }, callback);
};

export default logReviewGPTFeedbackClicked;
